import React, {FC, useState} from "react";
import {ProjectVisit} from "@traas/lib/src/api/dto/ProjectVisit";
import {ModalFooter} from "@traas/lib/src/components/layout/ModalProvider";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {ErrorBag} from "../api/api";
import {useNavigate} from "react-router";
import {useApiService} from "../../../lib/src/api/hooks/useApiService";
import config from "../config";
import {getToken} from "@ventumsoftware/react-toolkit";

export const DeleteProjectVisitModal: FC<{ visit: ProjectVisit }> = (props) => {
  const navigate = useNavigate();
  const {projectVisitService} = useApiService(config, getToken, navigate)
  const [errors, setErrors] = useState<ErrorBag>({})

  const confirm = async () => {
    await projectVisitService.delete(props.visit.id)
    navigate(`/werkbezoeken`)
  }

  return <div>
    <div>
      <strong>Let op!</strong> Je staat op het punt om het werkbezoek <strong>{props.visit.name}</strong> te verwijderen.
    </div>
    {errors ?
      <span className={'text-red-600'}>{Object.values(errors).flat().join(', ')}</span>
      : null}

    <ModalFooter text={'Verwijderen'} icon={faTrash} onSubmit={confirm} />
  </div>
}